import { render } from "./ManagerBranchView.vue?vue&type=template&id=c84e5dde&scoped=true"
import script from "./ManagerBranchView.vue?vue&type=script&lang=js"
export * from "./ManagerBranchView.vue?vue&type=script&lang=js"

import "./ManagerBranchView.vue?vue&type=style&index=0&id=c84e5dde&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c84e5dde"]])

export default __exports__